import {lazy} from 'react';

export const SliderLazy = lazy(() => import(/* webpackChunkName: "slider" */ '.'));
